var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgActivationImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3228_1853)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.5 16H1.5C0.67 16 0 15.33 0 14.5V2.5C0 1.67 0.67 1 1.5 1H14.5C15.33 1 16 1.67 16 2.5V14.5C16 15.33 15.33 16 14.5 16ZM1.5 2C1.22 2 1 2.22 1 2.5V14.5C1 14.78 1.22 15 1.5 15H14.5C14.78 15 15 14.78 15 14.5V2.5C15 2.22 14.78 2 14.5 2H1.5Z",
    fill: "#999999"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.5 4C4.22 4 4 3.78 4 3.5V0.5C4 0.22 4.22 0 4.5 0C4.78 0 5 0.22 5 0.5V3.5C5 3.78 4.78 4 4.5 4ZM11.5 4C11.22 4 11 3.78 11 3.5V0.5C11 0.22 11.22 0 11.5 0C11.78 0 12 0.22 12 0.5V3.5C12 3.78 11.78 4 11.5 4ZM15.5 6H0.5C0.22 6 0 5.78 0 5.5C0 5.22 0.22 5 0.5 5H15.5C15.78 5 16 5.22 16 5.5C16 5.78 15.78 6 15.5 6Z",
    fill: "#999999"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3228_1853"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActivationImage);
export default __webpack_public_path__ + "static/media/activation_image.d7b0873982a3bb6272da411f8921b5c6.svg";
export { ForwardRef as ReactComponent };